export const styles = {
  statsCard: {
    p: 2,
    borderRadius: "12px",
    border: "1px solid #E8EAED",
    backgroundColor: "#FFFFFF",
    flex: 1,
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      transform: "translateY(-2px)",
    },
  },
  mainCard: {
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    border: "1px solid #E8EAED",
  },
  cardHeader: {
    borderBottom: "1px solid #ddd",
    background: "#F7F7FC",
    ".MuiCardHeader-title": {
      fontSize: "16px",
      fontWeight: "bold",
    },
    padding: "14px",
  },
  addButton: {
    bgcolor: "#1976d2",
    color: "white",
    fontWeight: 500,
    borderRadius: "8px",
    textTransform: "none",
    fontSize: "14px",
    px: 2,
    py: 1,
    "&:hover": {
      bgcolor: "#1565c0",
    },
  },
  emptyState: {
    textAlign: "center",
    py: 8,
    px: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "400px",
  },
  pageContainer: {
    padding: { xs: 2 },
    minHeight: "100vh",
  },
};
